import React, { createContext, useCallback, useEffect, useState } from 'react';

import StorageHelper from '../helpers/StorageHelper';
import AuthService from '../services/AuthService';

const AuthContext = createContext(null);

function AuthProvider({ children }) {
  const [user, setUser] = useState(StorageHelper.getUser());
  const [token, setToken] = useState(StorageHelper.getTokenApiV2());
  const [context, setContext] = useState(StorageHelper.getContext());

  const isAuthenticated = Boolean(token) && Boolean(user) && Boolean(context);

  const store = useCallback(({ user, token, token_sistema }) => {
    StorageHelper.setItem(StorageHelper.KEYS.USER, user);
    StorageHelper.setItem(StorageHelper.KEYS.TOKEN_API_V2, token);
    StorageHelper.setItem(StorageHelper.KEYS.TOKEN_USUARIO, token);
    StorageHelper.setItem(StorageHelper.KEYS.TOKEN_SISTEMA, token_sistema);

    setUser(user);
    setToken(token);
  }, []);

  const logout = useCallback(async () => {
    StorageHelper.clear();
    setToken(null);
    setUser(null);
    setContext(null);
  }, []);

  const login = useCallback(
    async (username, password) => {
      const { data } = await AuthService.login(username, password);
      await store(data);
      return data;
    },
    [store],
  );

  const loginDireto = useCallback(
    async (id_entidade, id_usuario, st_urlacesso) => {
      const { data } = await AuthService.loginDireto({ id_entidade, id_usuario, st_urlacesso });
      await store(data);
      return data;
    },
    [store],
  );

  // Espelhar para o storage
  useEffect(() => {
    StorageHelper.setItem(StorageHelper.KEYS.TOKEN_API_V2, token);
    StorageHelper.setItem(StorageHelper.KEYS.TOKEN_USUARIO, token);
  }, [token]);

  // Espelhar para o storage
  useEffect(() => {
    StorageHelper.setItem(StorageHelper.KEYS.USER, user);
  }, [user]);

  // Espelhar para o storage
  useEffect(() => {
    StorageHelper.setItem(StorageHelper.KEYS.CONTEXT, context);
  }, [context]);

  return (
    <AuthContext.Provider
      value={{
        login,
        loginDireto,
        logout,
        token,
        setToken,
        user,
        setUser,
        context,
        setContext,
        isAuthenticated,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export { AuthProvider };

export default AuthContext;
